if (!customElements.get('yc-featured-collection-tabs')) {
  class YcFeaturedCollectionTabs extends HTMLElement {
    connectedCallback() {

      function initTabs(section) {
        const navWrapper = section.querySelector('.yc-featured-tabs__nav-wrapper');
        const content = section.querySelector('.yc-featured-tabs__content');
        const navItems = section.querySelectorAll('.yc-featured-tabs__nav-item');
        const panels = section.querySelectorAll('.yc-featured-tabs__panel');
        const autoSwitch = section.dataset.autoSwitch === 'true';
        const autoSwitchInterval = parseInt(section.dataset.autoSwitchInterval, 10) * 1000 || 5000;
        let switchInterval;
        let touchStartX = 0;
        let touchStartY = 0;
        
        if (navItems.length === 0 || panels.length === 0) return;
  
        function switchTab(index) {
          navItems.forEach(n => n.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));
          
          const navItem = navItems[index];
          navItem.classList.add('is-active');
          if (panels[index]) {
            panels[index].classList.add('is-active');
          }
          
          if (navWrapper) {
            const scrollLeft = navItem.offsetLeft - (navWrapper.clientWidth / 2) + (navItem.clientWidth / 2);
            navWrapper.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }

          window.requestAnimationFrame(() => {
            const track = panels[index] && panels[index].querySelector('.yc-featured-tabs__track');
            if (track && track._updateArrows) track._updateArrows();
          });
        }

      function startAutoSwitch() {
        if (!autoSwitch) return;
        stopAutoSwitch();
        switchInterval = setInterval(() => {
          let currentIndex = Array.from(navItems).findIndex(item => item.classList.contains('is-active'));
          let nextIndex = (currentIndex + 1) % navItems.length;
          switchTab(nextIndex);
        }, autoSwitchInterval);
      }

      function stopAutoSwitch() {
        if (switchInterval) {
          clearInterval(switchInterval);
        }
      }

      // Add event listeners for flag clicks to show overlay
      const flags = section.querySelectorAll('.yc-featured-tabs__flag');
      flags.forEach(flag => {
        flag.addEventListener('click', (e) => {
          e.preventDefault();
          const mainImage = flag.closest('.yc-featured-tabs__main-image');
          if (mainImage) {
            const overlay = mainImage.querySelector('.yc-featured-tabs__overlay');
            if (overlay) {
              overlay.classList.add('is-visible');
              stopAutoSwitch(); // Pause auto switch while reading
            }
          }
        });
      });

      // Add event listeners to close overlay
      const overlays = section.querySelectorAll('.yc-featured-tabs__overlay');
      overlays.forEach(overlay => {
        const closeOverlay = (e) => {
          e.preventDefault();
          overlay.classList.remove('is-visible');
          startAutoSwitch();
        };

        overlay.addEventListener('click', closeOverlay);
      });

      navItems.forEach((navItem, index) => {
        navItem.addEventListener('click', () => {
          switchTab(index);
          startAutoSwitch();
        });
      });

      if (content) {
        let swipeFromCarousel = false;

        content.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;

          swipeFromCarousel = Boolean(event.target.closest('.yc-featured-tabs__track'));
          if (swipeFromCarousel) {
            stopAutoSwitch();
            return;
          }

          stopAutoSwitch();
          touchStartX = touch.screenX;
          touchStartY = touch.screenY;
        }, { passive: true });

        content.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const swipeThreshold = 50;
          let currentIndex;
          let deltaX;
          let deltaY;

          if (swipeFromCarousel) {
            swipeFromCarousel = false;
            startAutoSwitch();
            return;
          }

          if (!touch) {
            startAutoSwitch();
            return;
          }

          currentIndex = Array.from(navItems).findIndex((item) => item.classList.contains('is-active'));
          deltaX = touch.screenX - touchStartX;
          deltaY = touch.screenY - touchStartY;

          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeThreshold) {
            if (deltaX < 0) {
              switchTab((currentIndex + 1) % navItems.length);
            } else {
              switchTab((currentIndex - 1 + navItems.length) % navItems.length);
            }
          }

          startAutoSwitch();
        }, { passive: true });
      }

      section.addEventListener('mouseenter', stopAutoSwitch);
      section.addEventListener('mouseleave', startAutoSwitch);

      section.querySelectorAll('.yc-featured-tabs__track').forEach((track) => {
        const scroller = track.querySelector('.yc-featured-tabs__grid');
        const prevButton = track.querySelector('.yc-featured-tabs__arrow--prev');
        const nextButton = track.querySelector('.yc-featured-tabs__arrow--next');
        if (!scroller || !prevButton || !nextButton || track.dataset.bound === 'true') return;

        track.dataset.bound = 'true';

        const setArrow = (button, visible) => {
          button.hidden = !visible;
          button.disabled = !visible;
        };

        const positionArrows = () => {
          const image = scroller.querySelector('.yc-ft-product-vt__image');
          if (!image) return;

          const imageRect = image.getBoundingClientRect();
          const trackRect = track.getBoundingClientRect();
          if (!imageRect.height) return;

          const center = imageRect.top - trackRect.top + imageRect.height / 2;
          track.style.setProperty('--arrow-center', `${center}px`);
        };

        const updateArrows = () => {
          const panel = track.closest('.yc-featured-tabs__panel');
          if (!panel || !panel.classList.contains('is-active') || !scroller.clientWidth) return;

          positionArrows();

          const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          const scrollLeft = scroller.scrollLeft;
          const canScroll = maxScroll > 4;

          setArrow(prevButton, canScroll && scrollLeft > 4);
          setArrow(nextButton, canScroll && scrollLeft < maxScroll - 4);
        };

        const scrollByStep = (direction) => {
          const items = scroller.querySelectorAll('.yc-ft-product-vt');
          const item = items[0];
          if (!item) return;

          let step = item.getBoundingClientRect().width;
          if (items[1]) {
            const next = items[1].getBoundingClientRect().left - item.getBoundingClientRect().left;
            if (next > 0) step = next;
          }

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          scroller.scrollBy({
            left: direction * step,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        };

        scroller.addEventListener('scroll', updateArrows, { passive: true });
        prevButton.addEventListener('click', () => scrollByStep(-1));
        nextButton.addEventListener('click', () => scrollByStep(1));

        const observer = new ResizeObserver(() => updateArrows());
        observer.observe(scroller);
        const image = scroller.querySelector('.yc-ft-product-vt__image');
        if (image) observer.observe(image);

        track._updateArrows = updateArrows;
        updateArrows();
      });

      startAutoSwitch();
    }

    initTabs(this);

    if (window.Shopify && Shopify.designMode) {
      
      
      document.addEventListener('shopify:block:select', function(event) {
        const block = event.target;
        const section = block.closest('.yc-featured-tabs');
        if (!section) return;
        
        const index = block.getAttribute('data-index');
        const navItem = section.querySelector(`.yc-featured-tabs__nav-item[data-index="${index}"]`);
        
        if (navItem) navItem.click();
      });
    }
  
    }
  }
  customElements.define('yc-featured-collection-tabs', YcFeaturedCollectionTabs);
}
